module.exports = __webpack_public_path__ + "img/80.f5d7c994.jpg";